import { Link } from "@tanstack/react-router";
import { SectionHeading } from "./SectionHeading";

export function CollectionPlaceholder({
  eyebrow,
  title,
  subtitle,
}: {
  eyebrow: string;
  title: string;
  subtitle: string;
}) {
  return (
    <section className="mx-auto flex min-h-[70vh] max-w-3xl flex-col items-center justify-center px-6 py-32 text-center">
      <SectionHeading eyebrow={eyebrow} title={title} subtitle={subtitle} />
      <Link
        to="/"
        className="label-xs mt-10 border border-foreground px-8 py-4 transition-colors hover:bg-primary hover:text-primary-foreground"
      >
        Retour à l'accueil
      </Link>
    </section>
  );
}
